import * as React from 'react'

export default (on: boolean = true) => {
	const [coords, setCoords] = React.useState({ x: 0, y: 0 });
	const set = (e:MouseEvent) => setCoords({ x: e.clientX, y: e.clientY });

	React.useEffect(() => {
		const enable = () => window.addEventListener("mousemove", set);
		const disable = () => window.removeEventListener("mousemove", set);
		enable()
		return disable
	});

	return coords;
};